export class User {
  token: string | undefined;
  actions: string[] = [];
  personId: string | undefined;
  actionPersonId: string | undefined;
  username: string | undefined;
}
